import React from "react";
import type { RouteConfig } from "@/types/routestypes";

import Inventory from "@/pages/DistributorMerchant/SupplierManagement/Inventory/Inventory";
import PendingOrders from "@/pages/DistributorMerchant/SupplierManagement/PendingOrders/PendingOrders";
import SalesDetails from "@/pages/DistributorMerchant/SupplierManagement/Sales Details/SalesDetails";
import VendorPurchaseInvoice from "@/pages/DistributorMerchant/SupplierManagement/VendorPurchaseOrder/VendorPurchaseInvoice";
import ForgotPassword from "@/pages/DistributorMerchant/Auth/DisForgotPassword/DisForgotPassword";
import DisLoginOtpVerification from "@/pages/DistributorMerchant/Auth/DisLoginOTPVerification/DisLoginOtp";
import LandingPage from "@/pages/LandingPage/LandingPage";
import Retailer from "@/pages/DistributorMerchant/SupplierManagement/Retailer/Retailer";
import RetailerRequest from "@/pages/DistributorMerchant/SupplierManagement/Retailer/RetailerRequest";
import Order from "@/pages/DistributorMerchant/SupplierManagement/Order/Order";
import OrderListItem from "@/pages/DistributorMerchant/SupplierManagement/Order/OrderListItem/OrderListItem";
import ProductCatalogue from "@/pages/DistributorMerchant/SupplierManagement/ProductCatalogue/ProductCatalogue";
import Dashboard from "@/pages/DistributorMerchant/SupplierManagement/Dashboard/Dashboard";
import DisProductCatalogue from "@/pages/DistributorMerchant/RetailerManagement/ProductCatalogueDis/DisProductCatalogue";
import {
  GridViewOutlined as DashboardIcon,
  HomeOutlined as HomeIcon,
  Inventory2Outlined as WarehouseIcon,
  FormatListBulletedOutlined as InventoryIcon,
  InboxOutlined as StockIcon,
  ShoppingBagOutlined as PurchaseOrderIcon,
  ShoppingCartOutlined as ShoppingCart,
  LocalOfferOutlined as ProductCatalogueIcon,
  DescriptionOutlined as SalesOrderIcon,
  CreditCardOutlined as SalesInvoiceIcon,
} from "@mui/icons-material";

const DistSalesInvoice = React.lazy(
  () => import("@/pages/DistributorMerchant/SupplierManagement/Sales Invoice/distSalesInvoice")
);

const DisRegister = React.lazy(
  () => import("@/pages/DistributorMerchant/Auth/DisRegister/DisRegister")
);
const DisForgotPassword = React.lazy(
  () =>
    import(
      "@/pages/DistributorMerchant/Auth/DisForgotPassword/DisForgotPassword"
    )
);
const DisLogin = React.lazy(
  () => import("@/pages/DistributorMerchant/Auth/DisLogin/DisLogin")
);
const DisOtpVerification = React.lazy(
  () =>
    import(
      "@/pages/DistributorMerchant/Auth/DisResetPassOtpVerification/Disotp-verification"
    )
);
const Warehouse = React.lazy(
  () =>
    import("@/pages/DistributorMerchant/SupplierManagement/Warehouse/Warehouse")
);
const Supplier = React.lazy(
  () =>
    import("@/pages/DistributorMerchant/SupplierManagement/Supplier/Supplier")
);
const Stock = React.lazy(
  () => import("@/pages/DistributorMerchant/SupplierManagement/Stock/Stock")
);
const AccountingDetails = React.lazy(
  () =>
    import(
      "@/pages/DistributorMerchant/SupplierManagement/AccountingDetails/AccountingDetails"
    )
);
const PurchaseOrder = React.lazy(
  () =>
    import(
      "@/pages/DistributorMerchant/SupplierManagement/PurchaseOrder/PurchaseOrder"
    )
);
// const Addsupplier=React.lazy(()=>import('@/pages/DistributorMerchant/SupplierManagement/Supplier/AddSupplier'))
//REtailer Routes
const RetailerPurchase = React.lazy(() => import("@/pages/DistributorMerchant/RetailerManagement/Order/Order"))
let showSetting = true;
let showReport = true;
let roles: any;
let showDashboard360 = true;
let image = "";
// let permissionsArray: any = [];
// (() => {
//   let url: any = window.location.href
//   url = url.split('/')[2]
//   if (url === 'app.fieldforceconnect.com') {
//     image = 'assets/media/sidebar/expenseLogo.svg'
//   } else {
//     image = 'assets/media/sidebar/dollar.svg'
//   }
//   let currentUser: any;
//   getPermissions$().subscribe(x => {
//     currentUser = { Permissions: x.Permissions, }
//     roles = x.currentUser
//     currentUser.Permissions.forEach((element: any) => {
//       permissionsArray.push(element.SystemName);
//     });
//     if (permissionsArray.includes('AllUsersData') || permissionsArray.includes('CustomFieldManagement') || permissionsArray.includes('CatalogueView') || permissionsArray.includes('AttendanceSettings') || permissionsArray.includes('CompanySettingsEdit') || permissionsArray.includes('ExpenseSettings') || permissionsArray.includes('CRMSettings') || permissionsArray.includes('OrderSettings') || permissionsArray.includes('LeaveSetting') || permissionsArray.includes('TerritoryMaster')) {
//       showSetting = true;
//     }
//     else {
//       showSetting = false;
//     }
//     if (permissionsArray.includes('CustomerReportView') || permissionsArray.includes('ExpenseReportView') || permissionsArray.includes('AttendanceReportExport') || permissionsArray.includes('SalesReportView') || permissionsArray.includes('DealsReportView')) {
//       showReport = true;
//     } else {
//       showReport = false;
//     }
//     if (permissionsArray.includes('Top5Absentees') || permissionsArray.includes('Top5HalfDays') || permissionsArray.includes('Top5ExtraDays') || permissionsArray.includes('Top5PlannedLeaves') || permissionsArray.includes('Top5ClaimUpdate') || permissionsArray.includes('EmployeeLocation')
//       || permissionsArray.includes('Top5Expense') || permissionsArray.includes('Customer') || permissionsArray.includes('Top5CustomerOrder') || permissionsArray.includes('DealsAndPipeline') || permissionsArray.includes('OpportunityAgainstLeadSource') || permissionsArray.includes('LeadsOnAccountStageAgainstLeadSource') || permissionsArray.includes('Expense') || permissionsArray.includes('FeedLrm')
//       || permissionsArray.includes('TaskOverview') || permissionsArray.includes('TeamWiseTask') || permissionsArray.includes('ListView') || permissionsArray.includes('SalesOverView') || permissionsArray.includes('LeadSource') || permissionsArray.includes('LeadStatus')
//       || permissionsArray.includes('LeadStage') || permissionsArray.includes('Meetings') || permissionsArray.includes('Calls') || permissionsArray.includes("LostReason") || permissionsArray.includes("TagsByOpportunity") || permissionsArray.includes('TagsByWonOpportunity') || permissionsArray.includes('TagsByLostOpportunity') || permissionsArray.includes('ProductOrderStatus')) {
//       showDashboard360 = true;
//     }
//     else {
//       showDashboard360 = false;
//     }

//   })
// })()

const DisRoutes: {
  routes: Record<string, { path: string; element: React.ReactElement }>;
  publicRoutes: Record<string, { path: string; element: React.ReactElement }>;
  privateRoutes: Record<string, RouteConfig>;
} = {
  routes: {
    LANDING_PAGE: {
      path: "",
      element: <LandingPage />,
    },
  },
  publicRoutes: {
    DIS_REGISTER: {
      path: "registration",
      element: <DisRegister />,
    },
    DIS_LOGIN: {
      path: "login",
      element: <DisLogin />,
    },
    DIS_FORGOT_PASSWORD: {
      path: "forgot-password",
      element: <ForgotPassword />,
    },
    DIS_OTP_VERIFICATION: {
      path: "otp-verification",
      element: <DisOtpVerification />,
    },
    DIS_LOGIN_OTP_VERIFICATION: {
      path: "login-otp-verification",
      element: <DisLoginOtpVerification />,
    },
  },
  privateRoutes: {
    Distributor: {
      element: <Dashboard />,
      path: "dashboard",
      pageName: "Dashboard",
      sidebar: { show: true, icon: DashboardIcon },
      permissionName: true,
      roles: ["distributor"],
    },
    RETAILER: {
      path: "Retails",
      pageName: "Retailer",
      sidebar: { show: true, icon: HomeIcon },
      permissionName: true,
      roles: ["distributor"],

      children: {
        MAIN: {
          element: <Retailer />,
          roles: ["distributor"],
          path: "",
          sidebar: { show: true, icon: HomeIcon },
          pageName: "Retailer",
          permissionName: true,
        },

        RETAILERREQUEST: {
          element: <RetailerRequest />,
          roles: ["distributor"],
          path: "request",
          sidebar: { show: true, icon: HomeIcon },
          pageName: "Retailer Request",
          permissionName: true,
        },
      },
    },
    Warehouse: {
      element: <Warehouse />,
      path: "warehouse",
      pageName: "Warehouse",
      sidebar: { show: true, icon: WarehouseIcon },
      permissionName: true,
      // permissionName:''_rightSideContainer_988k1_43
      roles: ["distributor"],
    },
    Inventory: {
      element: <Inventory />,
      path: "Inventory",
      pageName: "Inventory",
      sidebar: { show: true, icon: InventoryIcon },
      permissionName: true,
      // permissionName:''_rightSideContainer_988k1_43
      roles: ["distributor"],
    },
    Stock: {
      element: <Stock />,
      path: "Stock",
      pageName: "Stock",
      sidebar: { show: true, icon: StockIcon },
      permissionName: true,
      // permissionName:''_rightSideContainer_988k1_43
      roles: ["distributor"],
    },
    PurchaseOrder: {
      element: <PurchaseOrder />,
      path: "PurchaseOrder",
      pageName: "Purchase Order",
      sidebar: { show: true, icon: PurchaseOrderIcon },
      permissionName: true,
      // permissionName:''_rightSideContainer_988k1_43
      roles: ["distributor"],
    },

    RetailerPurchase: {
      element: <RetailerPurchase />,
      path: "retailer-order",
      pageName: "Purchase Order",
      sidebar: { show: true, icon: PurchaseOrderIcon },
      permissionName: true,
      // permissionName:''_rightSideContainer_988k1_43
      roles: ["retailer"],
    },

    ProductDisCatalogue: {
      element: <DisProductCatalogue />,
      path: "ProductCatalogue",
      pageName: "Product Catalogue",
      sidebar: { show: true, icon: ProductCatalogueIcon },
      permissionName: true,
      roles: ["retailer"],
    },

    // AccountDetails: {
    //   element: <AccountingDetails />,
    //   path: "AccountDetails",
    //   pageName: "Accounting",
    //   sidebar: { show: true, icon: "" },
    //   permissionName: true,
    //   // permissionName:''_rightSideContainer_988k1_43
    //   roles: ["distributor"],
    // },

    Order: {
      element: <Order />,
      path: "Order",
      pageName: "Sales Order",
      sidebar: { show: true, icon: SalesOrderIcon },
      permissionName: true,
      roles: ["distributor"],
    },
    OrderList: {
      element: <OrderListItem />,
      path: "orders-list/:orderID",
      pageName: "orders-list",
      sidebar: { show: false, icon: "" },
      permissionName: true,
      roles: ["distributor"],
    },
    ProductCatalogue: {
      element: <ProductCatalogue />,
      path: "ProductCatalogue",
      pageName: "Product Catalogue",
      sidebar: { show: true, icon: ProductCatalogueIcon },
      permissionName: true,
      roles: ["distributor"],
    },
    SalesInvoice: {
      element: <DistSalesInvoice />,
      path: "SalesInvoice",
      pageName: "Sales Invoice",
      sidebar: { show: true, icon: SalesInvoiceIcon },
      permissionName: true,
      roles: ["distributor"],
    },
    // Sales: {
    //   element: <SalesDetails />,
    //   path: "SalesDetails",
    //   pageName: "Sales Details",
    //   sidebar: { show: true, icon: "" },
    //   roles: ["distributor"],
    // },
  },

  //  VendorPurchaseInvoice:{
  //   element:<VendorPurchaseInvoice/>,
  //   path:"VendorPurchaseInvoice",
  //   pageName:"Vendor Purchase Invoice",
  //   sidebar:{show:true,icon:''}
  //  },
} as const;

export default DisRoutes;
